// extracted by mini-css-extract-plugin
module.exports = {"column":"rates_table_header_column_column__N9ncL","columnContent":"rates_table_header_column_columnContent__1ocsc","columnLabel":"rates_table_header_column_columnLabel__1Z5S8"};